import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CaretRight, ChatCircleDots, MagnifyingGlass } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";

export default function Pesan() {
  const navigate = useNavigate();
  const [contacts, setContacts] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/chat/contacts").then((r) => setContacts(r.data));
  }, []);

  const term = q.trim().toLowerCase();
  const filtered = !term ? contacts : contacts.filter((c) =>
    (c.name || "").toLowerCase().includes(term) ||
    (c.children || []).join(" ").toLowerCase().includes(term) ||
    (c.last_message || "").toLowerCase().includes(term)
  );

  return (
    <div>
      <PageHeader title="Pesan" back={false} />
      <div className="px-5 pt-4">
        <div className="relative mb-3">
          <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
          <input data-testid="pesan-search" value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Cari nama atau isi pesan..."
            className="w-full bg-white border border-stone-200 rounded-full py-2.5 pl-10 pr-4 text-sm outline-none focus:border-primary" />
        </div>
        <div className="space-y-2">
        {filtered.map((c, i) => (
          <motion.button
            key={c.id}
            data-testid={`contact-${c.id}`}
            initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.04 }}
            onClick={() => navigate(`/pesan/${c.id}`)}
            className="w-full bg-white rounded-2xl border border-stone-200/60 p-3.5 flex items-center gap-3 shadow-sm active:scale-[0.98] transition-transform"
          >
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
              <span className="font-heading font-bold text-primary text-lg">{c.name?.[0]}</span>
            </div>
            <div className="flex-1 text-left">
              <p className="font-semibold text-stone-800 text-sm">{c.name}</p>
              <p className="text-stone-400 text-xs">
                {c.role === "guru" ? "Guru Kelas" : c.children?.length ? `Ortu: ${c.children.join(", ")}` : "Orang Tua"}
              </p>
            </div>
            <CaretRight size={16} className="text-stone-300" />
          </motion.button>
        ))}
        {filtered.length === 0 && (
          <div className="flex flex-col items-center mt-16 text-stone-400">
            <ChatCircleDots size={48} weight="duotone" />
            <p className="mt-2 text-sm">{term ? "Tidak ada hasil pencarian." : "Belum ada kontak."}</p>
          </div>
        )}
        </div>
      </div>
    </div>
  );
}
